uniform vec2 resolution;
uniform float devicePixelRatio;
uniform float time;
varying vec2 vUv;

#pragma glslify: blendNormal = require(./../../shaders/blend-normal.glsl)
#pragma glslify: betweenSin = require(./../../shaders/between-sin.glsl)
#pragma glslify: betweenCos = require(./../../shaders/between-cos.glsl)
#pragma glslify: rotate2DMat3 = require(./../../shaders/rotate-2D-matrix3.glsl)
#pragma glslify: gain = require(./../../shaders/gain.glsl)

vec3 sdgBox(in vec2 p, in vec2 b) {
    vec2 w = abs(p) - b;
    vec2 s = vec2(p.x < 0.0 ? -1 : 1, p.y < 0.0 ? -1 : 1);
    float g = max(w.x, w.y);
    vec2 q = max(w, 0.0);
    float l = length(q);
    return vec3((g > 0.0) ? l : g, s * ((g > 0.0) ? q / l : ((w.x > w.y) ? vec2(1, 0) : vec2(0, 1))));
}

float circles(vec2 p) {

    return step(0.04, length(p));
}

// https://iquilezles.org/articles/sdfrepetition/
float repeatedCircles( vec2 p, float s )
{

    float interval = 1000.0;
    float t = gain(mod(time,interval)/interval, 0.9);
    t - 0.5;
    p = (rotate2DMat3(t * 3.14159265359 * 0.5) * vec3(p, 1.0)).xy;

    vec2 id = round(p/s);
    vec2  o = sign(p-s*id); // neighbor offset direction
    
    float d = 1e20;
    for( int j=0; j<2; j++ )
    for( int i=0; i<2; i++ )
    {
        vec2 rid = id + vec2(i,j)*o;
        vec2 r = p - s*rid;
        d = min( d, circles(r) );
    }
    return d;
}

// vec3 sdgRound( in vec2 p, in float r )
// {
//     vec3 dis_gra = sdgBox(p);
//     return vec3( dis_gra.x - r, dis_gra.yz );
// }

vec4 background() {
    vec2 st = gl_FragCoord.xy / devicePixelRatio;
    float v = 0.0;
    float width = 40.0;
    st.x += st.y * 1.0;
    v = smoothstep(0.5, 0.51, mod(st.x, width) / width);
    return vec4(vec3(v), 1.0);
}

vec4 rect() {
    vec2 originalUvs = vec2(vUv.x * (resolution.x / resolution.y), vUv.y);
    originalUvs -= vec2(0.5);
    vec2 uvs = vec2(vUv.x * (resolution.x / resolution.y), vUv.y);
    uvs.x += sin(time*0.001) * 0.2;
    uvs.y += cos(time*0.001) * 0.2;
    uvs -= vec2(0.5);
    float box = sdgBox(uvs, vec2(0.15, 0.2)).x;

    float borderWidth = 0.01;
    float isBorder = smoothstep(borderWidth, borderWidth + fwidth(box), abs(box));
    vec3 borderColor = vec3(0.0, 0.0, 0.0);

    vec3 interiorColor = vec3(1.0, 1.0, 1.0);
    
    vec3 a = vec3(1.0);
    vec3 b = vec3(0.0);

    float c = repeatedCircles(originalUvs, betweenSin(0.1, 0.2, time * 0.0005));

    interiorColor = mix(a, b, c);

    vec3 color = vec3(0.0);
    color = mix(borderColor, interiorColor, isBorder);

    return vec4(color, 1.0 - smoothstep(borderWidth, borderWidth + fwidth(box), box));
}

void main() {

    vec2 uvs = vec2(vUv.x * resolution.x / resolution.y);

    vec4 color = vec4(0.0, 0.0, 0.0, 1.0);

    color = blendNormal(color, background());
    color = blendNormal(color, rect());

    gl_FragColor = color;
}